import { defineComponent as _defineComponent } from 'vue'
import { modelViewerStore } from '@/store/modelViewer.store'
import { CsFlex, CsProgressLinear } from '@consteel/csuetify'
import Vue, { computed, onMounted, ref } from 'vue'
import {
  InfoTable,
  LineLoadTable,
  LoadTransferSurfaceTable,
  NodalLoadTable,
  StructuralMemberTable,
  SectionTable,
  LoadCaseTable,
  StructuralPlateTable,
  SupportPointTable,
  SurfaceLoadTable,
  HaunchedStructuralMemberTable,
} from './Info'
import ModelInformation from './Info/ModelInformation.vue'
import { StructuralMember, StructuralViewModel } from '@consteel/straw'
import { computedAsync } from '@vueuse/core'
import worker from 'simple-web-worker'


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoTab',
  setup(__props) {

const workerLoading = ref(false)

const tableComponents = {
  InfoTable,
  LineLoadTable,
  LoadTransferSurfaceTable,
  NodalLoadTable,
  StructuralMemberTable,
  SectionTable,
  LoadCaseTable,
  StructuralPlateTable,
  SupportPointTable,
  SurfaceLoadTable,
  HaunchedStructuralMemberTable,
}

onMounted(() => {
  // register table components
  Object.entries(tableComponents).forEach(([name, component]) => {
    Vue.component(name, component)
  })
})

const onlyOneSelected = computed((): boolean => {
  return modelViewerStore.selectedIds.length === 1
})

const moreThanOneItemSelected = computed((): boolean => {
  return modelViewerStore.selectedIds.length > 1
})

const selectedIds = computed((): string[] => {
  return modelViewerStore?.selectedIds || []
})

const showSectionTable = computed((): boolean => {
  return selectedItemsHaveTheSameParent.value && moreThanOneItemSelected.value
})

const showLoadTable = computed((): string | undefined => {
  if (!modelViewerStore.activeLoadId || !modelViewerStore.model.viewModel) return undefined
  return 'LoadCaseTable'
})

const currentSelectionTypeName = computed((): string | undefined => {
  if (!onlyOneSelected.value || !modelViewerStore.model.viewModel) return undefined
  //megkeressük az első

  let selectionTypeName = getSelectedItemTypeName(modelViewerStore.model.viewModel)

  //ha nincs benne az elsőbe és van második modellünk, akkor megnézzük abban is
  if (modelViewerStore.secondaryModel?.viewModel && !selectionTypeName) {
    selectionTypeName = getSelectedItemTypeName(modelViewerStore.secondaryModel.viewModel)
  }

  return selectionTypeName
})

const currentComponentName = computed((): string | undefined => {
  if (
    !currentSelectionTypeName.value ||
    !(`${currentSelectionTypeName.value}Table` in tableComponents)
  ) {
    console.warn(`${currentSelectionTypeName.value}Table not found`)
    return undefined
  }

  return `${currentSelectionTypeName.value}Table`
})

const compare = computed((): boolean => {
  return !!(
    modelViewerStore.model.rawSmadsteelModel && modelViewerStore.secondaryModel.rawSmadsteelModel
  )
})

const selectedItemsHaveTheSameParent = computedAsync<boolean>(
  async () => {
    workerLoading.value = true

    if (!modelViewerStore.model.viewModel) {
      workerLoading.value = false
      return false
    }

    const res: boolean = await worker.run(
      (selectedIds: string[], members: StructuralMember[]) => {
        if (!selectedIds.length) return false

        const firstlySelectedItemSectionId = members.find((member) => member.id === selectedIds[0])
          ?.section.id

        for (let i = 1; i < selectedIds.length; i++) {
          const currentItemId = members.find((member) => member.id === selectedIds[i])?.section.id

          if (currentItemId !== firstlySelectedItemSectionId) return false
        }

        return true
      },
      [selectedIds.value, modelViewerStore.model.viewModel.structuralMembers]
    )

    workerLoading.value = false
    return res
  },
  false,
  workerLoading
)

const getSelectedItemTypeName = (viewModel: StructuralViewModel): string | undefined => {
  return viewModel?.objects.find((obj) => obj.id === modelViewerStore.selectedIds[0])?.typeName
}

return { __sfc: true,workerLoading, tableComponents, onlyOneSelected, moreThanOneItemSelected, selectedIds, showSectionTable, showLoadTable, currentSelectionTypeName, currentComponentName, compare, selectedItemsHaveTheSameParent, getSelectedItemTypeName, CsFlex, CsProgressLinear, SectionTable, LoadCaseTable, ModelInformation }
}

})